import { OPERATIONS } from '@quadminds/shared/commons';
import { IAccountSchema } from './account-schema.interface';
import { ICarrierSchema } from './carrier-schema.interface';
import { IDriverSchema } from './driver-schema.interface';
import { ILocationSchema } from './location-schema.interface';
import { IOrderSchema } from './order-schema.interface';
import { ISemitrailerSchema } from './semitrailer-schema.interface';
import { IVehicleSchema } from './vehicle-schema.interface';
import { CertificationLevels, CheckpointStatusEnum, StepStatusEnum } from '../../enums';

export interface TriggerOrder {
    checkpointIndex: number;
    stepIndex: number;
}

export interface IStepSchema {
    type: string;
    icon: string;
    name: string;
    finishTripsInProgress: boolean;
    normalDuration: string;
    maxDuration: string;
    minDuration: string;
    customerId?: string | null;
    action?: string | null;
    slug?: string | null;
    completedAt?: string | null;
    triggeredAt?: string | null;
    overwritePlanned?: string | null;
    plannedAt?: string | null;
    estimatedAt?: string | null;
    stateDefinition?: string | null;
    status?: StepStatusEnum | null;
    scheduleEnd?: string | null;
    duration?: string | null;
    triggerWithCertification?: boolean;
    finishTripAfter?: string;
    manualTrigger?: boolean;
}

export interface IOrderCheckpointSchema {
    order: IOrderSchema;
    label: string;
    operation?: OPERATIONS;
}

export interface IOrderCheckpointAsset {
    level: CertificationLevels;
    code?: string;
    operation?: OPERATIONS;
    url?: string;
    timestamp: string;
    comment?: string;
    createdBy?: string;
}

export interface IOrdersInfoLocationSchema {
    name: string;
    code?: string;
    address?: string;
}

export interface IOrdersInfoSchema {
    location?: IOrdersInfoLocationSchema;
    certificationPin?: string;
    sta?: string;
    visitedAt?: string;
    delay?: string;
    diff?: string;
    totalPendingOrders: number;
    totalSucceededOrders: number;
    totalPartialOrders: number;
    totalFailedOrders: number;
    orders: IOrderCheckpointSchema[];
    signatures?: IOrderCheckpointAsset[];
    comments?: Omit<IOrderCheckpointAsset, 'url'>[];
    photos?: IOrderCheckpointAsset[];
}

export interface ICheckpointRouteSchema {
    id: string;
    name: string;
}

export interface ICheckpointSchema {
    checkpointDefinitionId: string;
    stateDefinition?: string | null;
    transitionStateDefinition?: string | null;
    name: string;
    steps: IStepSchema[];
    location?: ILocationSchema | string;
    type: string;
    visitStatus: string;
    dwellTime?: number;
    inTransit?: boolean | null;
    status?: CheckpointStatusEnum | null;
    ordersInfo?: IOrdersInfoSchema;
    createdByOrganizationId?: string;
    triggeredAt?: string;
    checkpointIndex?: number;
    isStopover?: boolean;
    isPlanned?: boolean;
    routeToArrive?: ICheckpointRouteSchema;
    theoreticalMetersAfter?: number;
    account?: IAccountSchema | null;
    unitChange?: ICheckpointUnitChangeSchema | null;
}

/** Logistic unit taking over from this checkpoint onwards. Stopover checkpoints only. */
export interface ICheckpointUnitChangeSchema {
    carrier?: ICarrierSchema | null;
    vehicle?: IVehicleSchema | null;
    driver?: IDriverSchema | null;
    semitrailers?: ISemitrailerSchema[] | null;
    changedAt?: string | null;
}
